import { IconName } from '@wegroup/design-system';
import { PartyType } from '@parties/src/types';
import { useQuery } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';

interface AnvaFlowsProductCatalogueResponse {
  items: AnvaProduct[];
  count: number;
}
export interface AnvaProductTag {
  id: number;
  name: string;
  icon_key?: IconName;
}

export type AnvaProductStatus = 'ACTIVE' | 'UNDER_CONSTRUCTION' | 'DISABLED';

export interface AnvaProduct {
  id: string;
  anva_id: string;
  name: string;
  status: AnvaProductStatus;
  insurance: Insurance;
  insurance_company: Insurance_company;
  tag: AnvaProductTag;
  coverages: CoveragesItem[];
  party_type: PartyType;
  terms_link?: string | null;
  insurance_card_link?: string | null;
  can_be_closed_as_loose_policy: boolean;
  documents: AnvaProductDocument[];
  packages: AnvaProductPackage[];
}

export interface AnvaProductPackage {
  id: number;
  name: string;
  enabled: boolean;
  excluded_from_discounts: boolean;
  excluded_coverages_from_discounts?: {
    id: number;
    code: string;
    name: string;
  };
  discounts: AnvaProductPackageDiscount[];
}

interface AnvaProductPackageDiscount {
  id: number;
  percentage: number;
  minimum_amount_of_policies: number;
  maximum_amount_of_policies: number;
}

export interface AnvaProductDocument {
  id: number;
  type: string;
  code: string;
  name: string;
  enabled: boolean;
}
interface Insurance {
  id: string;
  name: string;
  company: string;
  type: string;
  options: string[];
  affinity: string;
}
interface Insurance_company {
  id: string;
  name: string;
  code: string;
  form: string;
}
interface CoveragesItem {
  code?: string;
  id: string;
  risk_object: string;
  insurance_product_ids: string[];
  insurance_company: string;
  premium: number;
  payment_interval: string;
  insured_value: number;
  deductible: string;
  description: string;
  name: string;
  due_date: string;
  enabled?: boolean;
}

export const getAnvaFlowsProductCatalogue = async (entityType: PartyType) => {
  const { data, isError } = await wgApi.get<AnvaFlowsProductCatalogueResponse>(
    `/v1/api/anvaproducts`,
    {
      query: { entity_type: entityType },
    },
  );
  if (isError) throw new Error();
  return data;
};

export const getUseAnvaProductsQKey = (entityType: PartyType) => [
  'flow-config',
  'anva',
  'products',
  entityType,
];

export const useAnvaProducts = (entityType: PartyType) => {
  if (!entityType) {
    throw new Error('entityType is required');
  }

  return useQuery(
    getUseAnvaProductsQKey(entityType),
    () => getAnvaFlowsProductCatalogue(entityType),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );
};
